import { gql } from '@apollo/client';

export default gql`
  mutation sendInvoiceEmailMutation($invoiceId: String!) {
    sendInvoiceEmail(invoiceId: $invoiceId) {
      id
    }
  }
`;
